// extracted by mini-css-extract-plugin
export var svgAmber = "b2_jx";
export var svgBlack = "b2_jv";
export var svgBlue = "b2_jr";
export var svgDarkBlue = "b2_jn";
export var svgDarkGreen = "b2_jp";
export var svgGreen = "b2_jq";
export var svgLightBlue = "b2_js";
export var svgRed = "b2_jw";
export var svgWhite = "b2_jt";